const Index = () => import('@/pages/website/IndexPage.vue');
const HomePage = () => import('@/pages/website/HomePage.vue');
const About = () => import('@/pages/website/AboutPage.vue');
const Login = () => import('@/pages/website/LoginPage.vue');
const ForgotPassword = () => import('@/pages/website/ForgotPasswordPage.vue');
const ResetPassword = () => import('@/pages/website/ResetPasswordPage.vue');

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      default: HomePage,
    },
  },
  {
    path: '/agendar',
    name: 'index',
    components: {
      default: Index,
    },
  },
  {
    path: '/index',
    name: 'index2',
    components: {
      default: Index,
    },
  },
  {
    path: '/about',
    name: 'about',
    components: {
      default: About,
    },
  },
  {
    path: '/specialties',
    name: 'specialties',
    components: {
      default: () => import('@/pages/website/ServicesPage.vue'),
    },
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: Login,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    components: {
      default: ForgotPassword,
    },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    components: {
      default: ResetPassword,
    },
  },
  {
    path: '/:slug/reserva/:token',
    name: 'atomic-slot-share',
    components: {
      default: () => import('@/pages/website/AtomicSlotPage.vue'),
    },
    props: { default: true },
  },
  {
    path: '/servicios/:slug',
    name: 'service-seo',
    components: {
      default: () => import('@/pages/website/ServiceSeoPage.vue'),
    },
  },
  {
    path: '/:slug',
    name: 'professional-profile',
    components: {
      default: () => import('@/pages/website/ProfessionalProfilePage.vue'),
    },
  },
];

export default routes;
